import { HierarchyItem } from '../../common/components/filter/types';
import { ApiValueDataType } from '../types';

export type CustomSqlQueryValueBackendType = ApiValueDataType;

export interface FilterDataManager {
  queryKey: ReadonlyArray<unknown>;
  fetch: () => Promise<CustomSqlQueryValueBackendType[][] | undefined>;
  process: (
    data: CustomSqlQueryValueBackendType[][] | undefined
  ) => Promise<HierarchyItem[]>;
  count: (hierarchyItem: HierarchyItem[]) => number;
}

export enum EMPLOYMENT_TEMPORALITY {
  PRESENT = 'PRESENT',
  PAST = 'PAST',
  FUTURE = 'FUTURE',
}

export enum Ordering {
  GT = 1,
  LT = -1,
  EQ = 0,
}

export interface Ord<A> {
  compare(x: A, y: A): Ordering;
}

export type Where = string;
